import {Injectable} from '@angular/core';
import {HttpClient, HttpHandler} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {Observable} from 'rxjs';
import {ValidateRequest} from 'src/app/interfaces/mobicred/ValidateRequest';
import { ZapperUpdate } from 'src/app/interfaces/zapper/ZapperUpdate';

@Injectable()
export class ZapperApi extends HttpClient {
  private baseUrl = environment.production ? '/channel-virtual/api/v1' + '/zapper' : environment.baseUrl + '/zapper';

  public constructor(handler: HttpHandler) {
    super(handler);
  }

  public initializeZapperTransaction(sessionToken: string): Observable<any> {
    const url = this.baseUrl + '/initialize' + '/' + sessionToken;
    return super.get(url);
  }

  public updateZapperTransaction(sessionToken: string, zapperUpdate: ZapperUpdate): Observable<any> {
    const url = this.baseUrl + `/update/${sessionToken}`;
    return super.post(url, zapperUpdate);
  }

  public pollZapperTransactionStatus(sessionToken: string): Observable<any> {
    const url = this.baseUrl + `/poll/${sessionToken}`;
    return super.get(url);
  }

}
